import React, { useEffect, useState } from 'react'
import "../../assets/css/style.css";
import eyeoff from "../../assets/img/logo2 1.png"
import { API } from '../../services/api';
import { ApiHelper } from '../../helpers/ApiHelper';
import { useNavigate, useParams } from "react-router-dom";
function EmailVerify() {
    const navigate = useNavigate();
    const { token } = useParams();
    const [mailStatus, setMailStatus] = useState('')
    useEffect(() => {
        emailVerify();
    }, [])
    const emailVerify = async () => {
        const formData = {
            emailtoken: token
        }
        await ApiHelper.post(API.emailVerify, formData)
            .then((resData) => {
                setMailStatus(resData.data.status)
                if(resData.data.status){
                    navigate('/')
                }
            })
            .catch((err) => {
                console.log(err, 'err');
            });
    }

    return (
        <div >
            
        </div>
    )
}

export default EmailVerify